export const CONTACT_ROUTES = [
  {
    path: '/contacts',
    name: 'ContactList',
    component: () => import('./views/ContactList.vue'),
  },
  {
    path: '/contacts/create',
    name: 'CreateContact',
    component: () => import('./views/CreateContact.vue'),
  },
  {
    // The :id is a dynamic parameter that Vue Router passes to the component
    path: '/contacts/:id/edit',
    name: 'EditContact',
    component: () => import('./views/EditContact.vue'),
  },
  {
    path: '/contacts/new-leads',
    name: 'NewLeads',
    component: () => import('./views/NewLeads.vue'),
  },
]
